import { render } from "./RecordList.vue?vue&type=template&id=7c95028a&scoped=true&ts=true"
import script from "./RecordList.vue?vue&type=script&lang=ts"
export * from "./RecordList.vue?vue&type=script&lang=ts"

import "./RecordList.vue?vue&type=style&index=0&id=7c95028a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c95028a"]])

export default __exports__